<template>
    <div>
        <div
            v-if="!question.spotify_track"
            @click="openSpotifyPopup()"
            class="track-select-box flex justify-center items-center mt-4 py-8 cursor-pointer"
        >
            <div class="empty-track">{{ $t('question_click_select_song') }}</div>
        </div>

        <div v-if="question.spotify_track" class="track-badge flex flex-col mt-4 p-2">
            <div class="flex justify-center items-center">
                <SpotifyPlayer
                    @playing="onSpotifyPlaying($event)"
                    :track-image="question.spotify_track.album_image"
                    :track-id="question.spotify_track.id"
                    :track-url="question.spotify_track.preview_url"
                    :track-playing="trackPlayingId"
                    :audio="audioSpotify"
                />
                <div class="ml-3 flex-1 shadow-text-none">
                    <h5 class="font-size-18 my-0">{{ question.spotify_track.name }}</h5>
                    <p class="mb-0 font-size-14 shadow-text-none">
                        <span class="text-muted">{{ $t('question_artists') }} :</span>
                        {{ question.spotify_track.artists_name }}
                    </p>
                    <p class="mb-0 font-size-14 shadow-text-none">
                        <span class="text-muted">{{ $t('question_albums') }} :</span>
                        {{ question.spotify_track.album_name }}
                    </p>
                </div>
            </div>
            <div class="flex flex-col w-full md:w-auto" v-if="!approvalPending">
                <a
                    @click="openSpotifyPopup()"
                    class="btn btn-info font-size-14 font-opensans mb-2"
                    title="Select the other song"
                >
                    {{ $t('question_button_select_song') }}
                </a>
                <a class="btn btn-danger font-size-14 font-opensans" title="Delete song" @click.stop="onDeleteSong">
                    {{ $t('question_button_delete_song') }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import SpotifyPlayer from '@/components/SpotifyPlayer'
import popup from '@/lib/popup.js'

export default {
    components: {
        SpotifyPlayer
    },

    props: {
        question: {
            type: Object,
            required: true
        },

        questionIndex: {
            type: Number,
            required: true
        },

        audioSpotify: {
            type: HTMLAudioElement
        },

        approvalPending: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            trackPlayingId: null
        }
    },

    methods: {
        openSpotifyPopup() {
            this.$emit('open-spotify-popup')
        },

        onSpotifyPlaying(id) {
            this.trackPlayingId = id
        },

        onDeleteSong() {
            popup.confirm(this.$t('question_alert_delete_song'), () => {
                this.clearAudio()
                this.$store.commit('deleteSong', this.questionIndex)
            })
        },

        clearAudio() {
            this.audioSpotify.pause()
            this.trackPlayingId = null
        }
    }
}
</script>

<style>
</style>